<ngx-spinner></ngx-spinner>
<div class="detail-box" [ngClass]="isActive ? 'active-mobile':''">
    <div class="mobile_head">
        <a href="javascript:void()" (click)="remove()" class="back_link">
            <span class="icon-arrow-left"></span>
        </a>
        <h4>Saved Card</h4>
    </div>
    <div class="plan_box">
        <div class="row">
            <div class="col-12 col-md-12 col-lg-6">
                <div class="card_box">
                    <span class="betch">Default</span>
                    <div class="card_logo">
                        <img src="assets/images/mastercard_logo.png" />
                    </div>
                    <div class="card_data">
                        <div class="w-100">
                            <div class="d-flex justify-content-between">
                                <span>Card Number</span>
                                <a href="javascript:void(0)" class="delete_link">Delete</a>
                            </div>
                            <h5>XXXX-XXXX-XXXX-5690</h5>
                            <p class="date">Expiry Date: 6/2023</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-12 col-lg-6">
                <div class="card_box">
                    <div class="card_logo">
                        <img src="assets/images/visa-card.png" />
                    </div>
                    <div class="card_data">
                        <div class="w-100">
                            <div class="d-flex justify-content-between">
                                <span>Card Number</span>
                                <a href="javascript:void(0)" class="delete_link">Delete</a>
                            </div>
                            <h5>XXXX-XXXX-XXXX-5690</h5>
                            <p class="date">Expiry Date: 6/2023</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>